import _defineProperty from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types-create authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { objectSpread } from '@polkadot/util';
export var XCM_MAPPINGS = ['AssetInstance', 'Fungibility', 'Junction', 'Junctions', 'MultiAsset', 'MultiAssetFilter', 'MultiLocation', 'Response', 'WildFungibility', 'WildMultiAsset', 'Xcm', 'XcmError', 'XcmOrder'];
export function mapXcmTypes(version) {
  return XCM_MAPPINGS.reduce(function (all, key) {
    return objectSpread(all, _defineProperty({}, key, "".concat(key).concat(version)));
  }, {});
}